<template>
<v-window v-model="window" touchless >
  <v-progress-linear v-if='loading' indeterminate :height='2' class='ma-0' >
  </v-progress-linear>
  <v-window-item >
    <request-status
      v-if='saveRequest'
      :request='saveRequest' />
    <v-list dense three-line dark >
      <appointment-list-item :appointment='appointment'
        :with-color-coding='false'
        :with-status-chips='true'
        :with-action='false' />
    </v-list>
    <v-layout >
      <v-flex>
        <v-list three-line >
            <v-dialog v-model="viz.daymodal" lazy width='325' >
              <v-list-tile slot='activator' >
                <v-list-tile-avatar>
                <v-icon >event</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                <v-list-tile-title v-if='!timeData.date' >Day</v-list-tile-title>
                <v-list-tile-title v-else >
                  <v-btn @click.stop='dateDelta(-1)' class='ma-0 hidden-xs-only' icon >
                    <v-icon >chevron_left</v-icon></v-btn>
                  {{dateformat(timeData.date, 'ddd DD MMM')}}
                  <v-btn @click.stop='dateDelta(1)'
                    class='ma-0 hidden-xs-only' icon >
                  <v-icon >chevron_right</v-icon>
                  </v-btn>
                </v-list-tile-title>
                <v-list-tile-sub-title>click to change selected day</v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-avatar v-if='appointment.day'>
                <v-icon >check</v-icon>
                </v-list-tile-avatar>
              </v-list-tile>

              <v-date-picker
                v-model="timeData.date"
                @input='viz.daymodal = false'
                full-width scrollable actions autosave >
              </v-date-picker>
            </v-dialog>

            <v-divider></v-divider>
            <v-list-tile>
              <v-list-tile-avatar>
                  <v-icon>access_time</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content >
                  <v-list-tile-title style='height:32px;'>
                    <v-dialog v-model="viz.starttime" lazy width='325'  >
                        <v-chip small slot='activator' >
                          <span v-if='!timeData.start' >Start time</span>
                          <span v-else >{{timeData.start}}</span>
                        </v-chip>
                        <v-card flat>
                          <v-time-picker full-width
                            @input='startTimeChanged'
                            v-model="timeData.start" scrollable format="24hr" autosave >
                          </v-time-picker>
                          <v-card-actions>
                            <v-btn @click='viz.starttime = false' flat >Done</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @click='viz.starttime = false; viz.endtime = true' >Choose end time <v-icon>arrow_forward</v-icon></v-btn>
                          </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-icon small>arrow_forward</v-icon>
                    <v-dialog v-model="viz.endtime" lazy width='325' >
                        <v-chip small slot='activator' >
                          <span v-if='!timeData.end' >End time</span>
                          <span v-else >{{timeData.end}}</span>
                        </v-chip>
                        <v-card flat >
                          <v-time-picker full-width
                            @input='endTimeChanged'
                            :min='timeData.start'
                            v-model="timeData.end" scrollable format="24hr" autosave >
                          </v-time-picker>
                          <v-card-actions>
                            <v-btn flat @click='viz.endtime=false; viz.starttime = true' ><v-icon>arrow_back</v-icon>Change start time</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn @click='viz.endtime=false' flat >Done</v-btn>
                          </v-card-actions>
                        </v-card>
                    </v-dialog>
                  </v-list-tile-title>
                  <v-list-tile-sub-title v-if='timeData.start && timeData.end'>
                    {{timeData.difference}} minutes
                  </v-list-tile-sub-title>
                  <v-list-tile-sub-title v-else >
                    Choose a start and end time
                  </v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-avatar v-if='timeData.start && timeData.end'>
                <v-icon >check</v-icon>
              </v-list-tile-avatar>
            </v-list-tile>
            <v-divider></v-divider>

            <v-list-tile single-line :disabled='!messageTarget' >
              <v-list-tile-avatar >
                <v-progress-circular indeterminate
                  v-if='apptDetailReq.loading || clientReq.loading' color='amber' width='2' />
                <v-checkbox v-else
                  :disabled='!messageTarget'
                  v-model='notifications' ></v-checkbox>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  Notify the customer of the change?
                </v-list-tile-title>
                <v-list-tile-sub-title v-if='messageTarget' >
                  <v-chip
                    outline class="v-chip--x-small" color='primary' >
                    <v-icon
                      v-if="message.type === 'Email'"
                      small left >email</v-icon>
                    <v-icon
                      v-if="message.type === 'SMS'"
                      small left >phone</v-icon>
                    {{messageTarget}}
                  </v-chip>
                </v-list-tile-sub-title>
                <v-list-tile-sub-title v-else >
                  Notifications are send via {{message.type}}, and {{client.first_name}} has no
                  <span v-if='message.type === "Email"' >email address</span>
                  <span v-if='message.type === "SMS"' >phone number</span>
                  <v-icon color='amber' >warning</v-icon>
                </v-list-tile-sub-title>

                <v-list-tile-sub-title v-if='notifications === true' >
                  We'll send an {{message.type}} to the client informing them that their appointment has been rescheduled
                </v-list-tile-sub-title>
                <v-list-tile-sub-title v-else >
                  No notifications will be sent
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-avatar >
                <v-icon v-if='notifications' >notifications_on</v-icon>
                <v-icon v-else >notifications_off</v-icon>
              </v-list-tile-avatar>
            </v-list-tile>
        </v-list>
        <!-- <v-list class='mx-2'>
          <clash-list
            v-if='appointment && appointment.id'
            :appointment-id='appointment.id'
            :from-date='formattedStartTimeString'
            :to-date='formattedEndTimeString' >
          </clash-list>
        </v-list> -->

        <v-list dense >
          <v-subheader class='overline'>Reschedule</v-subheader>
          <v-list-tile >
            <v-list-tile-content >
              <v-list-tile-sub-title  class='overline' >From</v-list-tile-sub-title>
              <v-list-tile-title>
                {{dateformat(appointment.start_time, 'ddd DD MMM \\at HH:mma')}}
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-content>
              <v-list-tile-sub-title class='overline' >To</v-list-tile-sub-title>
              <v-list-tile-title>
                <v-icon class='mr-4' small>arrow_forward</v-icon>
                {{dateformat(formattedAppointment.new_start_time, 'ddd DD MMM \\at HH:mma')}}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-card flat>
          <v-divider></v-divider>
          <v-card-actions :class='mobileCardActionsClasses' :style='mobileCardActionsStyles' >
            <v-btn @click='resetDateTime' flat text >Reset</v-btn>
            <span v-if='clientErrors && clientErrors.length > 0' class='orange--text subheading' >
              <v-icon class='ml-2 mr-2' color='orange' >warning</v-icon>
              {{clientErrors[0]}}
            </span>
            <v-spacer></v-spacer>
            <v-btn
              :loading='loading'
              :disabled='!isValid || !isNewTime'
              @click='save' color='primary' >
              Reschedule</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex sm6 class="hidden-xs-only">
        <practitioner-day-view with-title with-date-bar block-events with-week
          v-if='practitioner && timeData && timeData.date'
          :practitioner='practitioner'
          @slotSelected='setStartTime'
          :date.sync='timeData.date'
          :preview-event='previewEvent'
          class='ma-2 elevation-10' />
      </v-flex>
    </v-layout>

  </v-window-item>
  <v-window-item >
    <v-layout >
      <v-flex></v-flex>
      <v-flex xs12 sm6 lg3 >
        <v-card class='text-xs-center ma-4' >
          <v-icon size='72' color='green' class='ma-4' >check_circle</v-icon>
          <blockquote class='blockquote' >
            Appointment Rescheduled
          </blockquote>
          <v-list dense v-if='batchId' >
            <v-subheader class='overline' >Notifications:</v-subheader>
            <batch-id-list :batch-id='batchId' >
            </batch-id-list>
          </v-list>

          <v-list class='my-0 py-0' three-line v-if='updatedAppointment && updatedAppointment.id' >
            <v-subheader class='overline' >Updated appointment:</v-subheader>
            <appointment-list-item with-status-chips
              :with-color-coding='false'
              :appointment='updatedAppointment'
              :with-ction=false
              :with-tags=false >
            </appointment-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-card-actions >
            <v-spacer></v-spacer>
            <v-btn @click='init();$emit("close")' flat text >Done</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex>
      </v-flex>
    </v-layout>
  </v-window-item>
</v-window>
</template>
<script>
import moment from 'moment'
import RequestsMixin from '@/mixins/requests'
// import ClashList from '@/components/appointment/ClashList'
import BatchIdList from '@/components/communications/BatchIdList'
import AppointmentListItem from '@/components/appointment/AppointmentListItem'
import PractitionerDayView from '@/components/calendar/PractitionerDayView.vue'
import {mapGetters} from 'vuex'
import Vue from 'vue'

export default {
  name: 'Reschedule',
  mixins: [RequestsMixin],
  components: {
    // ClashList,
    BatchIdList,
    AppointmentListItem,
    PractitionerDayView
  },
  props: {
    appointment: { type: Object, default: () => { return {} } },
    standAlone: true
  },
  data () {
    return {
      reqId: 'reschedule-request',
      window: 1,
      batchId: null,
      loading: false,
      saveRequest: false,
      saveRequestStatus: false,
      updatedAppointment: null,
      apptDetailReq: {
        resource: 'ag.practitioner.appointments'
      },
      clientReq: {
        resource: 'ag.clients'
      },
      messageReq: {
        resource: 'ag.settings.messages',
        resourceId: 'appointment_reminder'
      },
      viz: {
        daymodal: false,
        starttime: false,
        endtime: false
      },
      timeData: {
        date: null,
        start: null,
        end: null
      },
      notifications: true
    }
  },
  mounted () {
    this.init()
    if (!this.messageTarget) {
      this.notifications = false
    }
  },
  watch: {
    appointmentId () {
      this.init()
    },
    relationship () {
      if (this.relationshipId) {
        this.$store.commit('addClient', this.relationship)
      }
    },
    saveRequestStatus () {
      if (this.saveRequestStatus === 200) {
        // this.$emit('appointmentrescheduled', this.saveRequest)
        this.window = 1
      }
    },
    formattedAppointment () {
      this.$emit('input', this.formattedAppointment)
    },
    messageTarget () {
      if (!this.messageTarget) {
        this.notifications = false
      }
    }
  },
  computed: {
    ...mapGetters(['getPractitionerById']),
    serverError () {
      if (this.saveRequestStatus === -1) {
        return 'Unable to connect to the internet. Please check your internet connection'
      }
      if (this.saveRequestStatus >= 500) {
        return 'Something went wrong. Please try again.'
      }
    },
    appointmentDetail () {
      return this.getObjectPath(this.apptDetailReq, 'result', {})
    },
    message () {
      return this.getObjectPath(this.messageReq, 'result', {})
    },
    practitioner () {
      if (this.appointment && this.appointment.practitioner) {
        if (isNaN(this.appointment.practitioner) && this.appointment.practitioner.id) {
          return this.appointment.practitioner
        } else {
          return this.getPractitionerById(this.appointment.practitioner)
        }
      }
      return null
    },
    relationshipId () {
      return this.getObjectPath(this.appointment, 'computed_relationship_id')
    },
    relationship () {
      return this.getObjectPath(this.clientReq, 'result', {})
    },
    client () {
      let serverClient = this.getObjectPath(this.appointmentDetail, 'client', null)
      if (serverClient) { return serverClient }
      if (this.appointment && this.appointment.client) {
        if (isNaN(this.appointment.client)) {
          return this.appointment.client
        } else {
          return this.getClientById(this.appointment.client)
        }
      }
    },
    isNewTime () {
      if (this.appointment && this.timeData && this.timeData.start && this.timeData.end) {
        return (
          this.timeData.start !== this.appointment.start ||
          this.timeData.end !== this.appointment.end ||
          this.timeData.date !== this.appointment.dt
        )
      }
      return false
    },
    previewEvent () {
      if (this.isNewTime) {
        return {
          start_time: this.timeData.start,
          end_time: this.timeData.end
        }
      }
      return null
    },
    messageTarget () {
      if (this.client && this.clientHasContacts(this.client)) {
        if (this.message.type === 'Email') {
          if (this.isRealEmail(this.client.email)) {
            return this.client.email
          }
        }
        if (this.message.type === 'SMS') { return this.client.phone_number }
      }
      return null
    },
    appointmentId () {
      return this.appointment.id
    },
    rescheduleRequest () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    startDateFormated () {
      return this.timeData.date
    },
    startMoment () {
      if (this.timeData && this.timeData.start) {
        // this doesnt work as expected with am / pm times
        return this.timeStringToMoment(this.timeData.start)
      }
    },
    formattedStartTimeString () {
      if (this.timeData && this.timeData.start) {
        let time = this.timeStringToMoment(this.timeData.start, this.timeData.date)
        return moment(time).utc().toISOString()
        // .format('YYYY-MM-DD HH:mm')
      }
    },
    formattedEndTimeString () {
      if (this.timeData && this.timeData.end) {
        let time = this.timeStringToMoment(this.timeData.end, this.timeData.date)
        return moment(time).utc().toISOString()
        // .format('YYYY-MM-DD HH:mm')
      }
    },
    clientErrors () {
      let errors = []
      if (this.appointmentLength <= 0) {
        errors.push('End time must be after start time')
      }
      return errors
    },
    isValid () {
      return this.clientErrors.length <= 0
    },
    formattedAppointment () {
      let data = {
        send_notifications: this.notifications,
        new_start_time: moment().startOf('hour'),
        new_end_time: moment().add(1, 'hour').startOf('hour')
      }
      if (this.timeData && this.timeData.start) {
        data['new_start_time'] = this.timeStringToMoment(this.timeData.start, this.timeData.date)
      }
      if (this.timeData && this.timeData.end) {
        data['new_end_time'] = this.timeStringToMoment(this.timeData.end, this.timeData.date)
      }
      return data
    },
    appointmentLength () {
      let start = moment(this.formattedAppointment.new_start_time)
      let end = moment(this.formattedAppointment.new_end_time)
      return moment.duration(end.diff(start)).asMinutes()
    }
  },
  methods: {
    init () {
      if (this.appointment && this.appointment.start_time) {
        this.timeData = this.fromAppointment(this.appointment)
      }
      this.window = 0
      this.batchId = null
      this.updatedAppointment = null
      this.loading = false
      this.saveRequest = false
      this.saveRequestStatus = false

      if (this.appointmentId) {
        this.apptDetailReq.resourceId = this.appointmentId
        this.$request('get', this.apptDetailReq)
      }
      this.getRelationship()
      this.getMessage()
    },
    getMessage () {
      this.$request('get', this.messageReq)
    },
    getRelationship () {
      if (this.relationshipId) {
        this.clientReq.resourceId = this.relationshipId
        this.$request('get', this.clientReq)
      }
    },
    setStartTime (data) {
      Vue.set(this.timeData, 'start', data.start)
      this.startTimeChanged()
    },
    allowedMinutes () {
      return [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60]
    },
    resetDateTime () {
      this.timeData = this.fromAppointment(this.appointment)
    },
    fromAppointment (appointment) {
      if (appointment.start_time && appointment.end_time) {
        let startMoment = moment(appointment.start_time)
        let endMoment = moment(appointment.end_time)
        let data = {
          date: startMoment.format('YYYY-MM-DD'),
          start: startMoment.format('HH:mm'),
          end: endMoment.format('HH:mm'),
          difference: moment.duration(endMoment.diff(startMoment)).asMinutes()
        }
        return data
      }
    },
    dateDelta (days) {
      let newdate = moment(this.timeData.date).add(days, 'days').format('YYYY-MM-DD')
      this.timeData.date = newdate
    },
    startTimeChanged () {
      let endMoment = moment(this.formattedAppointment.new_start_time)
                        .add(this.timeData.difference, 'minutes')

      this.timeData.end = endMoment.format('HH:mm')
    },
    endTimeChanged () {
      let startMoment = moment(this.formattedAppointment.new_start_time)
      let endMoment = moment(this.formattedAppointment.new_end_time)
      this.timeData.difference = moment.duration(endMoment.diff(startMoment)).asMinutes()
    },
    save () {
      let data = JSON.parse(JSON.stringify(this.formattedAppointment))
      data.new_start_time = moment(data.new_start_time).utc().format('YYYY-MM-DD HH:mm')
      data.new_end_time = moment(data.new_end_time).utc().format('YYYY-MM-DD HH:mm')
      this.loading = true
      this.saveRequestStatus = 0

      // remove the original appointment from the store
      // this.$store.commit('removeAppointment', this.appointment.id)
      this.performAction(
        this.$appointmentguru,
        'practitioner',
        'appointments',
        this.appointment.id,
        'reschedule',
        data
      ).then((result) => {
        this.batchId = result.data.batch_id
        this.saveRequest = result
        this.saveRequestStatus = result.status
        this.updatedAppointment = result.data
        // this.$emit('input', result.data)

        // update calendar:
        // this.$store.commit('removeAppointment', this.appointment.id)
        this.$store.commit('addAppointments', [result.data])

        this.loading = false
        this.window = 1
      })
      .catch((result) => {
        this.batchId = null
        this.loading = false
        if (result && result.response) {
          this.saveRequest = result.response
          this.saveRequestStatus = result.response.status
        } else {
          this.saveRequest = null
          this.saveRequestStatus = -1
        }
        // if it fails, add the original appointment back
        // this.$store.commit('addAppointment', [this.appointment])
      })
    }
      /* let data = {
        'practitioner': this.$store.getters.me.id,
        'appointment': this.appointment.id,
        'name': RESCHEDULE_PROCESS,
        'request_data': JSON.stringify(this.formattedAppointment)
      }
      this.$appointmentguru
        .resource('process')
        .id(this.reqId)
        .create(data)
    } */
  }
}
</script>




// WEBPACK FOOTER //
// Reschedule.vue?4e807255